import { gql } from "@apollo/client";

const PRODUCTO = 1;
const TECNOLOGIAS_MEDICAS = 2;

const GET_RECLAMO_DETALLE = gql`
query gestionReclamoById ( $idGestionReclamo: Int!) {
    gestionReclamoById( idGestionReclamo: $idGestionReclamo ){
        idGestionReclamo
        idTipoReclamo
        fechaRegistro
        idUsuarioCreador
        idUsuarioCreadorNavigation{
            nombre
            apellido
        }
        idDelegacion
        idDelegacionNavigation{
            idDelegacion    
            descripcion
        }
        fechaOcurrencia 
        contacto
        telefonoContacto
        empleado
        idCategoriaReclamo
        idCategoriaEFI
        idPaciente
        idCliente
        gestionReclamoProfesional{
            idProfesional
        }
        tipoInsumoReclamo{
            idInsumo
            lote
            fechaVencimiento
            numeroRemito
            fechaRemito
            cantidad
            identificadorInsumo
            idInsumoNavigation{
                descripcion
            }
        }
        numeroReclamo
        idEtapaReclamo
        idEstadoReclamo 
        descripcion
        descripcionCalidad
        accionInmediata
        accionInmediataCalidad
        idAreaReclamo
        idClasificacionReclamo
        idUsuarioResponsable
        evaluacionGestionReclamo{
            idEvaluacion
        }
        investigacion
        capa
        accionTomadaReclamo{
            decripcion
        }
        idSeguimientoFK
        descripcionCierre
        correspondeProfesional
        idCapaReclamo
        observacionFinal
        seguridadSaludPaciente
        calidadServicio
        justificacion
    }
}
`;
export default GET_RECLAMO_DETALLE;

export const adaptReclamoCompleto = (reclamo) => {
  return {
    idEtapaReclamo: reclamo?.idEtapaReclamo,
    idClasificacionReclamo: reclamo?.idClasificacionReclamo,
    stage1: {
      tipoReclamo: reclamo?.idTipoReclamo,
      fechaRegistro: reclamo?.fechaRegistro,
      idUsuarioCreador: reclamo?.idUsuarioCreador,
      usuario: `${reclamo?.idUsuarioCreadorNavigation?.nombre} ${reclamo?.idUsuarioCreadorNavigation?.apellido}`,
      idDelegacion: reclamo?.idDelegacion,
      fechaOcurrencia: reclamo?.fechaOcurrencia,
      contacto: reclamo?.contacto,
      telefonoContacto: reclamo?.telefonoContacto,
      empleado: reclamo?.empleado,
      idCategoriaReclamo: reclamo?.idCategoriaReclamo,
      idPaciente: reclamo?.idPaciente,
      idCliente: reclamo?.idCliente,
      profesionales: reclamo?.gestionReclamoProfesional?.map((prof) => prof.idProfesional),
      productos: reclamo?.tipoInsumoReclamo?.filter((x) => x.identificadorInsumo === PRODUCTO)?.map((x) => {
        const { identificadorInsumo, idInsumoNavigation, ...data } = x;
        return {
          ...data,
          nombre: idInsumoNavigation?.descripcion
        };
      }),
      tecnologiasMedicas: reclamo?.tipoInsumoReclamo?.filter((x) => x.identificadorInsumo === TECNOLOGIAS_MEDICAS)?.map((x) => {
        const { identificadorInsumo, idInsumoNavigation, ...data } = x;
        return {
          ...data,
          nombre: idInsumoNavigation?.descripcion
        };
      }),
      accionInmediata: reclamo?.accionInmediata,
      descripcion: reclamo?.descripcion
    },
    stage2: {
      idAreaReclamo: reclamo?.idAreaReclamo,
      idClasificacionReclamo: reclamo?.idClasificacionReclamo,
      descripcionCalidad: reclamo?.descripcionCalidad,
      accionInmediataCalidad: reclamo?.accionInmediataCalidad,
      idUsuarioResponsable: reclamo?.idUsuarioResponsable,
      evaluaciones: reclamo?.evaluacionGestionReclamo?.map((ev) => ev.idEvaluacion),
      seguridadSaludPaciente: reclamo?.seguridadSaludPaciente,
      calidadServicio: reclamo?.calidadServicio,
      justificacion: reclamo?.justificacion,
      idCategoriaEFI: reclamo?.idCategoriaEFI
    },
    stage3: {
      investigacion: reclamo?.investigacion,
      capa: reclamo?.capa,
      accionTomada: reclamo?.accionTomadaReclamo?.map((accion) => accion.decripcion) //TODO decripcion corregirse a descripcion cuando este fixeado en al api
    },
    stage4: {
      idSeguimientoFK: reclamo?.idSeguimientoFK,
      descripcionCierre: reclamo?.descripcionCierre,
      correspondeProfesional: reclamo?.correspondeProfesional,
      idCapaReclamo: reclamo?.idCapaReclamo
    },
    stage5: {
      observacionFinal: reclamo?.observacionFinal
    }
  };
};

export const adaptDelegacionCargada = (reclamo) => {
  return {
    id: reclamo?.idDelegacionNavigation?.idDelegacion,
    displayName: reclamo?.idDelegacionNavigation?.descripcion
  };
};